import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import SettingsIcon from '@mui/icons-material/Settings'
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  FormControlLabel,
  Box,
} from '@mui/material'
import Logo from 'components/Logo'
import { useRootLoaderData } from 'components/Root.loader'
import SearchBar from 'components/Search/Search'
import { LINK_TERMSOFUSE } from 'config'
import { sidebarWidth } from 'config'
import useMode from 'hooks/useMode'
import { useReducerContext, ActionKind } from 'hooks/useReducerContext'
import { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'

const AccountMenu = () => {
  const [accountMenuEl, setAccountMenuEl] = useState(null)
  const [_ctx, dispatch] = useReducerContext()
  const openLogoutDialog = () => {
    dispatch({ type: ActionKind.LOGOUT_OPEN })
  }
  const openAccountMenu = (e) => setAccountMenuEl(e.currentTarget)
  const closeAccountMenu = () => setAccountMenuEl(null)

  return (
    <>
      <IconButton
        aria-controls="account-menu"
        aria-haspopup="true"
        color="inherit"
        aria-label="menuitem"
        onClick={openAccountMenu}
        data-testid="account-menu"
      >
        <AccountCircleIcon />
      </IconButton>
      <Menu
        keepMounted
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        aria-label="menu"
        id="account-menu"
        anchorEl={accountMenuEl}
        open={Boolean(accountMenuEl)}
        onClose={closeAccountMenu}
      >
        <MenuItem
          component={Link}
          to="account-setting"
          onClick={closeAccountMenu}
          data-testid="account-menu-setting"
        >
          アカウント設定
        </MenuItem>
        <MenuItem
          onClick={() => {
            closeAccountMenu()
            openLogoutDialog()
          }}
          data-testid="account-menu-logout"
        >
          ログアウト
        </MenuItem>
      </Menu>
    </>
  )
}

const FAQMenu = () => {
  const [faqMenuEl, setFAQMenuEl] = useState(null)
  const openFAQMenu = (e) => setFAQMenuEl(e.currentTarget)
  const closeFAQMenu = () => setFAQMenuEl(null)

  return (
    <>
      <IconButton
        aria-controls="faq-menu"
        aria-haspopup="true"
        color="inherit"
        aria-label="menuitem"
        onClick={openFAQMenu}
        data-testid="faq-menu"
      >
        <HelpOutlineIcon />
      </IconButton>
      <Menu
        keepMounted
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        aria-label="menu"
        id="faq-menu"
        anchorEl={faqMenuEl}
        open={Boolean(faqMenuEl)}
        onClose={closeFAQMenu}
      >
        <MenuItem
          component="a"
          target="_blank"
          href={'https://line-works.com/ai-product/ocr/user-guide/'}
          onClick={closeFAQMenu}
          data-testid="faq-menu-help"
        >
          ヘルプ
        </MenuItem>
        <MenuItem
          component="a"
          href={'https://line-works.com/contactus/ai-product/technical-support/'}
          target="_blank"
          onClick={closeFAQMenu}
          data-testid="faq-menu-contact"
        >
          問い合わせ
        </MenuItem>
        <MenuItem
          component="a"
          href={LINK_TERMSOFUSE}
          target="_blank"
          onClick={closeFAQMenu}
          data-testid="faq-menu-terms"
        >
          利用規約
        </MenuItem>
      </Menu>
    </>
  )
}

const MenuBar = () => {
  const { mode } = useMode()
  const navigate = useNavigate()
  const rootData = useRootLoaderData()
  // TODO: refactor: be carefull! root data can be undefined
  const vSubGroupNames = rootData?.verifyGroups
  const showVerify = vSubGroupNames?.length > 0
  return (
    <div aria-label="menu">
      {showVerify && (
        <FormControlLabel
          control={
            <Switch
              checked={mode !== 'normal'}
              onChange={(e) => navigate(e.target.checked ? '/verify/home' : '/normal/home')}
              data-testid="switch-verify"
            />
          }
          label="Verify"
          labelPlacement="start"
        />
      )}
      <FAQMenu />
      <IconButton component={Link} to="settings" color="inherit" aria-label="menuitem">
        <SettingsIcon data-testid="settings" />
      </IconButton>
      <AccountMenu />
    </div>
  )
}

const Header = () => {
  const { mode } = useMode()
  const location = useLocation()

  const showSearchBar =
    location.pathname.endsWith('/deleted') || location.pathname.endsWith('/home')

  const hideSearchBar = mode !== 'normal' || !showSearchBar

  return (
    <AppBar sx={{ bgcolor: 'primary.light' }}>
      <Toolbar>
        <Link to="home" data-testid="header-title-logo">
          <Box sx={{ width: sidebarWidth - 3 * 8, pr: 4 }}>
            <Logo />
          </Box>
        </Link>
        <Box sx={{ flexGrow: 1 }}>
          <Box sx={hideSearchBar ? { display: 'none' } : {}}>
            <SearchBar />
          </Box>
        </Box>
        <MenuBar />
      </Toolbar>
    </AppBar>
  )
}

export default Header
